import React, { useEffect, useState } from 'react';
import Carousel from './Carousel';
import { getStores } from '../../services/api';
import { Store } from './model';
import Skeleton from '../skeleton/Skeleton';
import { Reveal } from '../common/Reveal';

export default function Location() {
    const [store, setStore] = useState<Store[]>();

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const data = await getStores();
                setStore([...data].sort((a, b) => a.order - b.order));
            } catch (error) {
                console.error('Error fetching stores:', error);
            }
        };

        fetchStores();
    }, []);

    return (
        <>
            <div className='min-h-[78vh]'>
                {/* livfarm greens */}
                <Reveal
                    as="section"
                    className='text-livos-green container'
                    style={{ marginTop: 150, marginBottom: 50 }}
                >
                    <div className="text-center gap gap-4">
                        <div className="flex justify-center">
                            <img src="/assets/images/location/location_box.svg" alt='Img not found' className="md:w-[288px] w-[150px]" />
                        </div>
                    </div>
                </Reveal>
                <Reveal as="section" className='container pl-[1px] pr-[1px] mb-[100px]' delay={0.1}>
                    <div className="max-w-screen-lg flex items-center justify-center mx-auto">
                        <div className="text-center w-full">
                            {store ? <Carousel store={store} /> : <Skeleton />}
                        </div>
                    </div>
                </Reveal>
            </div>
        </>
    );
}
